/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, Input, QueryList, ViewChildren} from '@angular/core';
import {CrmIssue, CrmIssueElastic, FileService} from 'compob2b-libs';
import {NgxDurationInputService} from '../../../../../admin-shared/services/ngx-duration-input.service';
import {translations} from '../../../../../../environments/translations.ru';
import {Observable} from 'rxjs';
import {SubtaskLinkStore} from '../subtask-links-issue/subtask-link.store';
import {TaskLinkStore} from '../task-links-issue/task-link.store';
import {NbPopoverDirective} from '@nebular/theme';

@Component({
    selector: 'app-issue-subtask-list',
    templateUrl: './issue-subtask-list.html',
    styleUrls: ['./issue-subtask-list.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class IssueSubtaskList {

  @Input() items: Observable<CrmIssueElastic[]>;
  @Input() issue: CrmIssue;
  @Input() store: SubtaskLinkStore | TaskLinkStore;
  @ViewChildren(NbPopoverDirective) popovers: QueryList<NbPopoverDirective>;

  public readonly translations = translations;

  constructor(private readonly fileService: FileService,
              private readonly durationService: NgxDurationInputService) {
  }

  getImageUri(picture: string, width: number = 96) {
    return picture === null ? null : this.fileService.getImageSrc(picture, width);
  }

  formatDuration(n: number) {
    return this.durationService.getDurationString(n);
  }

  deleteLink(issue: CrmIssueElastic) {
    if (this.canDelete() && this.store instanceof TaskLinkStore) {
      this.store.delete(this.issue.id, issue.id);
    }
  }

  canDelete(): boolean
  {
     return  this.store instanceof TaskLinkStore;
  }

  closeConfirm() {
    this.popovers.forEach(pop => {
      pop.hide();
    });
  }

}
